const $ = jQuery;

import 'perfect-scrollbar/css/perfect-scrollbar.css';
import '../sass/main.scss';

import M from 'materialize-css';

import stacktable from 'stacktable.js';

import Flickity from 'flickity/dist/flickity.pkgd.js';

import PerfectScrollbar from 'perfect-scrollbar'
import AutocompleteAjax from './hogo/AutocompleteAjax.js';
import scrollToElement from 'scroll-to-element';

import Banner from './hogo/Banner.js';
import DateSelect from './hogo/DateSelect.js';
import FlipCard from './hogo/FlipCard.js';
import Spinner from './hogo/Spinner.js';
import Toggler from './hogo/Toggler.js';
import Social from './hogo/Social.js';
import SynxisRates from './hogo/SynxisRates.js';


if (typeof MGMMSG !== 'undefined') {
    Materialize.toast(MGMMSG, 4000);
}


// CUSTOM SCROLLBARS
// =================
const flipCardContainers = document.querySelectorAll( '.flip-card-back .inner' );
for (var i = 0; i < flipCardContainers.length; i++)
{
    new PerfectScrollbar(flipCardContainers[i]);
}
const diningBookingContent = document.querySelectorAll( '.dining-booking-content-inner' );
for (var i = 0; i < diningBookingContent.length; i++)
{
    new PerfectScrollbar(diningBookingContent[i]);
}



// PARALLAX
// =================
$('.parallax').parallax();


// BOOK ROOM
// =========

if (typeof MGMENV !== 'undefined') {

    var macauRate = null;
    var cotaiRate = null;

    function updateRates(lowest, property)
    {

        var $rate = $('.rate-' + property);

        if ( ! lowest || ! lowest.rate) {
            $rate.removeClass('rate-exists').addClass('rate-error');
            //$rate.find('.rate-value').html('&nbsp;');

            // HARDCODE for demo TODO remove
            if (property === 'macau') {
                lowest = {
                    room_type: 'Grand Room',
                    rate: 1351,
                    currencycode: 'HKD'
                };
            } else if (property === 'cotai') {
                lowest = {
                    room_type: 'Resort Room',
                    rate: 1488,
                    currencycode: 'HKD'
                };
            }
            //$rate.find('.rate-value').html('HKD 1,111<sup>++</sup>');

            // Show no rates found.
            //return;
        }

        if (property === 'cotai') {
            lowest.room_type = 'Resort Room';
        }

        // Look up room image from our database.
        $.ajax({
            method: 'GET',
            dataType: 'text',
            url: '/api/rooms/featured-image',
            data: {
                name: lowest.room_type,
                site_id: property === 'macau' ? 2 : 3
            },
            complete: function (response) {
                $rate.find('.rate-image-fade').remove();
            },
            success: function (response) {
                if (parseInt(response, 10) !== 0) {
                    var img = new Image;

                    img.src = response;
                    img.className = 'rate-image-fade';

                    img.onload = function() {
                        $rate.find('.rate-image').append(img);
                    };
                }
            },
            error: function (response) {
                //
            }
        });

        if (lowest.rate) {
            var rate = lowest.rate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            $rate.find('.rate-value').html(lowest.currencycode + rate + '<sup>+</sup>');
        }

    }

    ////////////////////////////////////////////////////////////////////////////
    // MAINTENANCE
    ////////////////////////////////////////////////////////////////////////////
    var $bookForm = $('form.book-room');
    $('.rate-action a').on('click', function(e) {
        e.preventDefault();

        if (typeof SYNXIS_MAINTENANCE !== 'undefined' && SYNXIS_MAINTENANCE) {
            if (window.location.href.indexOf('/en')) {
                window.location = 'https://mgm.mo/en/maintenance/';
            } else if (window.location.href.indexOf('/zh-hant')) {
                window.location = 'https://mgm.mo/zh-hant/maintenance/';
            } else if (window.location.href.indexOf('/zh-hans')) {
                window.location = 'https://mgm.mo/zh-hans/maintenance/';
            }
        } else {
            var $this = $(this);

            $bookForm.find('input[name="Hotel"]').val($this.data('hotel'));

            $bookForm[0].submit();
        }
    });

    if (typeof SYNXIS_MAINTENANCE !== 'undefined' && SYNXIS_MAINTENANCE) {
        $('form.book-room').on('submit', function (e) {
            e.preventDefault();

            $('.rate').removeClass('rate-exists rate-error').addClass('rate-loading');
            $('.rates').slideDown(500, function () {
                scrollToElement( '.rates', {
                    duration: 1000,
                });
            });

            var properties = ['macau', 'cotai'];

            for (var i = 0; i < properties.length; i++) {

                var property = properties[i];

                var $rate = $('.rate-' + property);

                $rate.removeClass('rate-loading');

                $rate.removeClass('rate-error').addClass('rate-exists');

                updateRates({}, property);
            }

            return false;
        });
    }

    $('form.book-room').synxisRates({
        macauId: 23412,
        cotaiId: 79175,
        error: function(property) {
            var $rate = $('.rate-' + property);

            $rate.removeClass('rate-loading');

            if ( ! $rate[0]) {
                return;
            }

            updateRates(null, property);

            // $rate
            //     .removeClass('rate-loading rate-exists rate-error')
            //     .addClass('rate-no-value');

        },
        beforeRequest: function() {
            $('.rate').removeClass('rate-exists rate-error').addClass('rate-loading');
            $('.rates').slideDown(500, function() {
                scrollToElement( '.rates', {
                    duration: 1000,
                });
            });
        },
        success: function(lowest, property, nextRates) {

            var $rate = $('.rate-' + property);

            $rate.removeClass('rate-loading');

            // No element found for this returned property.
            if ( ! $rate[0]) {
                return;
            }


            $rate.removeClass('rate-error').addClass('rate-exists');

            updateRates(lowest, property);
        }
    });
}


// NEWSPAPER
// =========

$('#newspaper-carousel').each(function(e) {

    var langIndex = $(this).data('index');
    var $self = $(this);

    var newspaperCarousel = new Flickity($(this).find('.carousel')[0], {
        initialIndex: langIndex,
        adaptiveHeight: true,
        pageDots: false,
        prevNextButtons: false
    });

    $(this).find('.newspaper-carousel-pagination').on('click', 'button', function(e) {
        e.preventDefault();

        var select = $(this).data('select');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        newspaperCarousel.select(select);
    });

    newspaperCarousel.on('select', function() {
        var $el = $self.find('.newspaper-carousel-pagination').find('[data-select="' + newspaperCarousel.selectedIndex + '"]');

        $el.siblings().removeClass('active');
        $el.addClass('active');
    });

});


// RATES
// =====

// Animation
$('.rate-image').each(function() {
    var $this = $(this);

    setInterval(function() {
        $this.toggleClass('rate-image-active');
    }, 5000);
});

// Submit
var $bookForm = $('form.book-room');
$('.rate-action a').on('click', function(e) {

    e.preventDefault();

    var $this = $(this);

    $bookForm.find('input[name="Hotel"]').val($this.data('hotel'));

    $bookForm[0].submit();

});




// AUTOCOMPLETE
// ============
//var Search = new AutocompleteAjax(
$('#search').each(function(e) {
    var $this = $(this);

    $this.autocompleteAjax({
        ajax: {
            url: $this.data('url'),
            method: 'get',
            dataType: 'json',
            beforeSend: function () {},
            error: null
        },
        callback: function (res) {

        },
        minLength: 2,
        delay: 200
    });

});


// FLIP CARD EFFECTS IF NO CSS SUPPORT
// ===================================
$('.no-csstransforms3d .flip-card').on('mouseenter', function (e) {
    $(this).find('.flip-card-front').fadeOut(500);
}).on('mouseleave', function (e) {
    $(this).find('.flip-card-front').fadeIn(500);
});



// RESTAURANT BOOKING SLIDING CONTENT
// ==================================
$('.dining-booking-tabs a').on('click', function (e) {
    e.preventDefault();

    var $this = $(this),
        $target = $('#' + $this.data('target'));

    $this.parents('.dining-booking-tabs').addClass('active');
    $target.addClass('active');

    $target.find('.dining-booking-back').on('click', function (e) {
        e.preventDefault();

        $target.removeClass('active');
        $this.parents('.dining-booking-tabs').removeClass('active');
    });
});


// SIDE NAVS
// =========
var elements = document.querySelectorAll( '.sidenav' );
M.Sidenav.init(elements, {
    edge: 'right'
});


var elements = document.querySelectorAll( '.collapsible' );
M.Collapsible.init(elements, {
    onOpen: function(el) {
    },
    onClose: function(el) {
    }
});



// MODALS
// ======

$('.modal').modal({
    startingTop: '50%',
    endingTop: '5%'
});



// BOOKING DATE RANGES
// ===================



// ENABLE STACKTABLE
// =================

$('.stacktable').stacktable({
    myClass: 'hide-on-med-and-up'
});



// RESPONSIVE CLASSES
// ==================

var isMobile = false;
var $body    = $('body');

$(window).on('resize', function(e) {

    var $this = $(this),
        width = $this.width();

    if (width <= 768 && !isMobile) {
        $body.removeClass('desktop').addClass('mobile');
        isMobile = true;
    } else if (width > 768 && isMobile) {
        $body.removeClass('mobile').addClass('desktop');
        isMobile = false;
    }

}).trigger('resize');



// GALLERIES
// =========

$('.gallery').each(function () {
/** Flickity options */
    var $this = $(this),
        $slider = $this.find('.gallery-slider'),
        $thumbs = $this.find('.gallery-thumbs');

    var gallery = new Flickity($slider[0], {
        pageDots: false,
        arrowShape: 'M 0,50 L 80,00 L 80,100 Z'
    });

    if ($thumbs.get(0)) {
        var galleryThumbs = new Flickity($thumbs[0], {
            asNavFor: gallery.element,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            freeScroll: true,
            cellAlign: 'left'
        });
    }
});



// SITE SWITCHER
// =============
var elements = document.querySelectorAll('.site-switcher-toggle');
M.Dropdown.init(elements, {
    coverTrigger: false,
    constrainWidth: false,
});

var elements = document.querySelectorAll('.main-nav .dropdown-trigger');
M.Dropdown.init(elements, {
    coverTrigger: false,
    constrainWidth: false,
    hover: true,
});

var elements = document.querySelectorAll('.sidebar-toggle');
M.Dropdown.init(elements, {
    coverTrigger: false,
    alignment: 'center',
});

// FORMS
// =====
var elements = document.querySelectorAll('select');
M.FormSelect.init(elements, {});

var elements = document.querySelectorAll('.datepicker');
M.Datepicker.init(elements, {
    selectMonths: true,
    selectYears: 150,
    max: true,
});

$('input[data-triggers]').each(function (e) {
    var $this = $(this),
        $target = $('#' + $this.data('triggers')),
        name = $this.attr('name');

    $target.hide();

    function handleChange (e) {
        // Trigger uncheck on all others in the group.
        $('input[name=' + name + ']').each(function (e) {
            var $this = $(this),
                $target = $('#' + $this.data('triggers'));

            $target.hide();
        });

        if ($this.is(':checked')) {
            $target.show();
        } else {
            $target.hide();
        }
    }

    $this.on('click', handleChange);

});


$('input[data-enables]').each(function (e) {
    var $this = $(this),
        $target = $('#' + $this.data('enables')),
        name = $this.attr('name');

    $target.prop('disabled', true);

    function handleChange (e) {

        // Trigger uncheck on all others in the group.
        $('input[name=' + name + ']').each(function (e) {
            var $this = $(this),
                $target = $('#' + $this.data('enables'));

            $target.prop('disabled', true);
        });

        if ($this.is(':checked')) {
            $target.prop('disabled', false);
        } else {
            $target.prop('disabled', true);
        }
    }

    $this.on('change', handleChange);
}).trigger('change');
